import React from 'react';
import classes from './ChannelTagsDisplay.module.css';

export interface ChannelTagsDisplayProps {
  channelsString: string; // Space-separated channel string like "EMAIL SMS"
}

/**
 * Displays channels as styled tags (same design as organization usage overview)
 */
export const ChannelTagsDisplay: React.FC<ChannelTagsDisplayProps> = ({ channelsString }) => {
  if (!channelsString || channelsString === 'UNKNOWN') {
    return <span className={classes.noChannels}>-</span>;
  }

  // Split by space to get individual channels
  const channels = channelsString.split(' ').filter(Boolean);

  return (
    <div className={classes.channelsContainer}>
      {channels.map((channel, idx) => (
        <span key={idx} className={classes.channelTag}>
          {channel}
        </span>
      ))}
    </div>
  );
};
